"use client";
import { useState } from "react";
import { Box, CircularProgress, Skeleton } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import CategoryContainer from "./categoryContainer";
import { FooterImage } from "./FooterImage";
import ModalFilters from "./modals/ModalFilters";
import NavigationItems from "../booking/navigationitems";
//import MapWithClusters from "@/common/customElements/mapWithClusters";
import VideoCarousel from "./videoCarousel/videoCarousel";
import GoogleTranslationComponent from "../googleTranslate/GoogleTranslationComponent";
import filterIcon from "@/assets/images/icons/filter-icon.svg";
import CustomButton from "@/common/customElements/button";
import MapContainer from "@/common/customElements/customMapWithClusters/MapContainer";
import {
  CategoryDiv,
  CustomDiv,
  HorizontalCenterDiv,
  InlineDiv,
  VerticalCenterDiv,
} from "@/common/divs";
import { AlmostBoldText } from "@/common/texts";
import ActivitiesContainer from "@/components/home/activitiesContainer";
import HomeFilters from "@/components/home/filters";
import HomeHeader from "@/components/home/header";
import { useActivities } from "@/hooks/useActivities";
import { useActivitiesParseUrl } from "@/hooks/useActivitiesParseUrl";
import { useFixHydration } from "@/hooks/useFixHydration";
import { HomeHeaderProps, LocationProps } from "@/types/components";
import {
  NEUTRO_OVERLINE_COLOR,
  NEUTRO_TITLES_COLOR,
  PRIMARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";

const PageContent: React.FC<LocationProps & HomeHeaderProps> = ({
  latitude,
  longitude,
  city,
  category,
  radius,
}) => {
  const {
    filteredActivities,
    isLoading,
    valuesState,
    changeValuesForFetch,
    categories,
    parseTerm,
    parseSpecialTerm,
    communities,
    tags,
    mobilityTags,
    languages,
    activities,
    locations,
    cityFromLanding,
    isRefetching,
  } = useActivities(latitude, longitude, category, radius);

  useActivitiesParseUrl({
    categories: categories,
    parseTerm: parseTerm,
    mobilityTags: mobilityTags,
    tags: tags,
    languages: languages as any,
    valuesState: valuesState as any,
  });

  const [isMapView, setIsMapView] = useState<boolean>(false);
  const { t } = useTranslation();
  const [openFilters, setOpenFilters] = useState<boolean>(false);
  const reduceSectionWidth = useMediaQuery("(max-width:923px)");
  const isMobile = useMediaQuery("(max-width:640px)");

  const mounted = useFixHydration();

  if (!mounted) {
    return null;
  }
  return isMapView ?
      <CustomDiv style={{ position: "relative" }}>
        {isMobile && (
          <>
            <InlineDiv
              paddingY="30px"
              className="activities-list-items-container no-padding-map-view"
              style={{ gap: "6px", width: "fit-content", flexWrap: "wrap" }}
            >
              <NavigationItems
                previousPage="activity.details.recommendations"
                actualPage="activities.filter.map_view"
                actionToDo={() => setIsMapView(false)}
              />
            </InlineDiv>
            <CustomDiv className="activities-list-items-container no-padding-map-view">
              <InlineDiv
                style={{ flexWrap: "wrap", justifyContent: "space-between" }}
              >
                <CustomDiv marginY="7px">
                  <CustomButton
                    width="200px"
                    height="43px"
                    onClick={() => {
                      setOpenFilters(true);
                    }}
                    backgroundColor={SECONDARY_BUTTON_COLOR}
                    borderColor={NEUTRO_TITLES_COLOR}
                  >
                    <InlineDiv className="centerDiv">
                      <AlmostBoldText
                        style={{ marginTop: "-5px" }}
                        color={NEUTRO_TITLES_COLOR}
                      >
                        {t("activities.filter.advanced_filters")}
                      </AlmostBoldText>
                      <Image
                        style={{
                          marginTop: "1px",
                          marginLeft: "12px",
                          width: "22px",
                          height: "15px",
                        }}
                        src={filterIcon.src}
                        alt="filter"
                        width={22}
                        height={15}
                      />
                    </InlineDiv>
                  </CustomButton>
                </CustomDiv>
              </InlineDiv>
            </CustomDiv>
          </>
        )}
        <InlineDiv
          style={{
            gap: "12px",
            flexWrap: isMobile ? "wrap-reverse" : "nowrap",
          }}
        >
          <section
            style={{
              width:
                isMobile ? "100%"
                : reduceSectionWidth ? "35%"
                : "65%",
            }}
          >
            {!isMobile && (
              <>
                <InlineDiv
                  paddingY="30px"
                  className="activities-list-items-container no-padding-map-view"
                  style={{ gap: "6px", width: "fit-content", flexWrap: "wrap" }}
                >
                  <NavigationItems
                    previousPage="activity.details.recommendations"
                    actualPage="activities.filter.map_view"
                    actionToDo={() => setIsMapView(false)}
                  />
                </InlineDiv>
                <CustomDiv className="activities-list-items-container no-padding-map-view">
                  <InlineDiv
                    style={{
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                    }}
                  >
                    <CustomDiv marginY="7px">
                      <CustomButton
                        width="200px"
                        height="43px"
                        onClick={() => {
                          setOpenFilters(true);
                        }}
                        backgroundColor={SECONDARY_BUTTON_COLOR}
                        borderColor={NEUTRO_TITLES_COLOR}
                      >
                        <InlineDiv className="centerDiv">
                          <AlmostBoldText
                            style={{ marginTop: "-5px" }}
                            color={NEUTRO_TITLES_COLOR}
                          >
                            {t("activities.filter.advanced_filters")}
                          </AlmostBoldText>
                          <Image
                            style={{
                              marginTop: "1px",
                              marginLeft: "12px",
                              width: "22px",
                              height: "15px",
                            }}
                            src={filterIcon.src}
                            alt="filter"
                            width={22}
                            height={15}
                          />
                        </InlineDiv>
                      </CustomButton>
                    </CustomDiv>
                  </InlineDiv>
                </CustomDiv>
              </>
            )}
            <Box
              sx={{
                height: isMobile ? "auto" : "calc(100vh - 231px)", //HEADER_HEIGHT + FILTERS_DIV + PADDING
                overflowY: "auto",
              }}
            >
              <ActivitiesContainer
                isMobile={isMobile}
                imInMapView={true}
                filteredActivities={{ Actividades: activities ?? [] }}
                totalActivities={activities ?? []}
                isLoading={isLoading}
                isRefetching={isRefetching}
                locations={locations}
              />
            </Box>
          </section>

          <section
            style={{
              width:
                isMobile ? "100%"
                : (
                  window.screen.availWidth > 1600 &&
                  window.screen.availWidth < 2100
                ) ?
                  "80%"
                : "65%",
            }}
          >
            {locations && (
              <MapContainer
                isMobile={isMobile}
                locations={locations}
                center={{ lat: latitude, lng: longitude }}
                valuesState={valuesState}
                changeValuesForFetch={changeValuesForFetch}
              />
            )}
          </section>
        </InlineDiv>
        {openFilters && (
          <ModalFilters
            open={openFilters}
            setOpen={setOpenFilters}
            valuesState={valuesState as any}
            categories={categories}
            tags={tags}
            parseTerm={parseTerm}
            changeValuesForFetch={changeValuesForFetch}
            mobilityTags={mobilityTags}
            languages={languages as any}
          />
        )}
        {isLoading && (
          <VerticalCenterDiv
            width="100%"
            style={{
              justifyContent: "center",
              marginTop: "300px",
              zIndex: 99999,
            }}
          >
            <HorizontalCenterDiv width="100%">
              <CustomDiv
                background="#FFFFFF"
                paddingX="30px"
                paddingY="30px"
                style={{ borderRadius: "12px" }}
              >
                <CircularProgress size={150} />
              </CustomDiv>
              <Skeleton
                variant="rectangular"
                height={2400}
                animation={"wave"}
              />
            </HorizontalCenterDiv>
          </VerticalCenterDiv>
        )}
      </CustomDiv>
    : <>
        {isMobile ?
          <>
            <HomeHeader
              city={cityFromLanding ? cityFromLanding : city}
              valuesState={valuesState}
              changeValuesForFetch={changeValuesForFetch}
              categories={categories}
              parseSpecialTerm={parseSpecialTerm}
              communities={communities}
            />
            <CustomDiv style={{ marginTop: "10px", marginLeft: "10px" }}>
              <AlmostBoldText fontSize="18px">Recomendaciones</AlmostBoldText>
            </CustomDiv>
            <VideoCarousel city={cityFromLanding ? cityFromLanding : city} />
          </>
        : <>
            <HomeHeader
              city={cityFromLanding ? cityFromLanding : city}
              valuesState={valuesState}
              changeValuesForFetch={changeValuesForFetch}
              categories={categories}
              parseSpecialTerm={parseSpecialTerm}
              communities={communities}
            />
            <InlineDiv className="quick-category-filters">
              {categories.current.map(
                (category: {
                  id: number;
                  name: string;
                  selected: boolean;
                  i18_name: string;
                }) => (
                  <CategoryContainer
                    category={category}
                    key={category.id}
                    categories={categories}
                    parseTerm={parseTerm}
                  />
                ),
              )}
              <CategoryDiv
                onClick={() => {
                  changeValuesForFetch();
                }}
                style={{
                  backgroundColor: PRIMARY_BUTTON_COLOR,
                  alignContent: "center",
                  lineHeight: "15px",
                }}
              >
                {t("activities.filter.apply_filter")}
              </CategoryDiv>
            </InlineDiv>
          </>
        }

        <HomeFilters
          city={cityFromLanding ? cityFromLanding : city}
          valuesState={valuesState}
          categories={categories}
          parseTerm={parseTerm}
          tags={tags}
          changeValuesForFetch={changeValuesForFetch}
          mobilityTags={mobilityTags}
          languages={languages}
          setIsMapView={setIsMapView}
        />
        {activities ?
          activities?.length > 0 ?
            <InlineDiv paddingX="108px">
              <AlmostBoldText fontSize="14px" color={NEUTRO_OVERLINE_COLOR}>
                <GoogleTranslationComponent
                  text={`Mostrando ${activities.length} actividades`}
                />
              </AlmostBoldText>
            </InlineDiv>
          : null
        : null}
        <ActivitiesContainer
          isMobile={isMobile}
          totalActivities={activities ?? []}
          filteredActivities={filteredActivities}
          isLoading={isLoading}
          isRefetching={isRefetching}
        />
        <FooterImage />
      </>;
};

export default PageContent;
